import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class NotificationsAPI extends API {
	getNotifications() {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesiones_pendientes`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const notificationsAPI = new NotificationsAPI('/notificaciones');
